// 年限选项
export const yearOptions = [
  { label: '1年', value: 1 },
  { label: '2年', value: 2 },
  { label: '3年', value: 3 }
]

// 上架状态选项
export const launchStatusOptions = [
  { label: '已下架', value: 0 },
  { label: '上架中', value: 1 }
]

// 还款方式选项
export const productRepayMethods = [
  { label: '等额本息', value: 1 },
  { label: '等额本金', value: 2 },
  { label: '先息后本', value: 3 },
  { label: '到期还本付息', value: 4 },
  { label: '随借随还', value: 6 },
  { label: '其他约定还款', value: 5 }
]

// 实名认证状态选项
export const realNameStatusOptions = [
  { value: 1, label: '已认证' },
  { value: 0, label: '未认证' }
]

// 提现状态
export const payoutGradeOptions = [
  { value: 1, label: '待审核' },
  { value: 2, label: '提现成功' },
  { value: 3, label: '提现失败' }
]

// 结算方式选项
export const clearingFormOptions = [
  { value: 1, label: '线上结算' }
  // { value: 2, label: '线下结算' }
]

// 推荐产品选项
export const recommendProductsOptions = [
  { value: '0', label: '是' },
  { value: '1', label: '否' }
]

// 成员分类选项
export const memberTypeOptions = [
  { value: 1, label: '直系' },
  { value: 2, label: '非直系' }
]

// 结佣方式
export const commissionTypeOptions = [
  { value: 1, label: '按比例' },
  { value: 2, label: '按件数' },
  { value: 3, label: '无返佣' }
]

// 结算周期选项
export const settlementCycleOptions = [
  { value: 1, label: '按月' },
  { value: 2, label: '按日' },
  { value: 3, label: '按周' },
  { value: 4, label: '按季' }
]

// 结算节点选项
export const settlementNodeOptions = [
  { value: 1, label: '进件成功' },
  { value: 2, label: '授信通过' },
  { value: 3, label: '授信拒绝' },
  { value: 4, label: '已放款' },
  { value: 5, label: '已还款' },
  { value: 6, label: '支付成功' }
]

// 资金类型选项
export const fundTypeOptions = [
  { label: '银行', value: 1 },
  { label: '小贷', value: 2 }
]
export function getFundType(key: number) {
  const res = fundTypeOptions.find(el => el.value === key)
  return res?.label || '-'
}

// 合作状态选项
export const cooperateStatusOptions = [
  { label: '合作中', value: 0 },
  { label: '暂停合作', value: 1 }
]
export function getStatus(key: number) {
  const res = cooperateStatusOptions.find(el => el.value === key)
  return res?.label || '-'
}

// 产品分类选项
export const loanProductTypeOptions = [
  { label: '纳税贷', value: 1 },
  { label: '发票贷', value: 2 },
  { label: '流水贷', value: 11 },
  { label: '商户贷', value: 3 },
  { label: '个贷', value: 4 },
  { label: '车抵贷', value: 5 },
  { label: '房抵贷', value: 6 },
  { label: '中标贷', value: 7 },
  { label: '物流贷', value: 8 },
  { label: '设备租赁', value: 9 },
  { label: '信用卡', value: 10 }
]

// 产品来源选项
export const productSourceOptions = [
  { label: '直接拿码', value: 1 },
  { label: '客服拿码', value: 2 }
]

// 产品类型选项
export const productCategoryOptions = [
  { label: '线上', value: 1 },
  { label: '线下', value: 2 },
  { label: '信用卡', value: 3 }
]
// 产品类型选项
export const rakeBackTypeOptions = [
  { label: '有返佣', value: 1 },
  { label: '无返佣', value: 2 }
]

// 订单来源选项
export const orderResourceOptions = [
  { label: '推广商城', value: 1 },
  { label: '渠道直链', value: 2 },
  { label: '代进件', value: 3 }
]

// 账单类型选项
export const billTypeOptions = [
  { label: '产品返佣', value: 1 },
  { label: '渠道返佣', value: 2 },
  { label: 'KA调佣', value: 3 },
  { label: '会员返佣', value: 4 }
]

// 财务管理 账单状态
export const billStatusOptions = [
  { label: '待审核', value: 1 },
  { label: '审核拒绝', value: 2 },
  { label: '审核通过', value: 3 }
]

// 进件订单状态
export const incomingOrderStatusOptions = [
  { label: '进件成功', value: 1, bgcColor: '#F0F9EB', color: '#5DC144' },
  { label: '授信通过', value: 2, bgcColor: '#F0F9EB', color: '#5DC144' },
  { label: '授信拒绝', value: 3, bgcColor: '#FEF0F0', color: '#F44D4D' },
  { label: '已放款', value: 4, bgcColor: '#F4F4F5', color: '#909399' },
  { label: '已还款', value: 5, bgcColor: '#F4F4F5', color: '#909399' }
]

// 业务模式
export const businessModeOptions = [
  { label: '有客户，需要找产品', value: 1 },
  { label: '有产品，需要找客户', value: 2 }
]

// 擅长产品/客户选项
export const beGoodAtProductOrCustomerOptions = [
  { label: '个贷为主', value: 1 },
  { label: '企业为主', value: 2 },
  { label: '车抵为主', value: 3 },
  { label: '房抵为主', value: 4 },
  { label: '综合业务', value: 5 }
]

// 申请列表状态
export const applyStatusOptions = [
  { label: '待跟进', value: 1 },
  { label: '跟进中', value: 2 },
  { label: '已完结', value: 3 }
]

// 客户类型选项
export const customerTypeOptions = [
  { label: '个人', value: 1 },
  { label: '企业', value: 2 }
]
// 审批状态
export const approvalStatusOptions = [
  { label: '待审批', value: '1' },
  { label: '审批通过', value: '2' },
  { label: '审批拒绝', value: '3' }
]
// 社群类型
export const groupTypeOptions = [
  { label: '个人', value: '1' },
  { label: '企业', value: '2' },
  { label: '车辆', value: '3' },
  { label: '房产', value: '4' },
  { label: '其他', value: '5' }
]
// 社群状态
export const groupStateOptions = [
  { label: '已上架', value: '1' },
  { label: '已下架', value: '2' }
]
export enum IdentityEnum {
  intermediary = 1,
  service,
  customer
}
export enum SpeacializeEnum {
  enterprise = 1,
  person,
  business
}
export const identityCustomer = {
  label: '助贷服务',
  children: [
    { value: 4001, label: '民间配资' },
    { value: 4002, label: '信用卡办理' },
    // { value: 4003, label: '短信通道' },
    // { value: 4004, label: '大数据服务' },
    // { value: 4005, label: '助贷系统' },
    { value: 4006, label: '公积金提取' },
    { value: 4007, label: '垫资过桥' },
    { value: 4008, label: '债务重组' },
    // { value: 4009, label: '律所服务' },
    { value: 4010, label: '资产包对接' },
    { value: 4011, label: '征信服务' },
    { value: 4012, label: '办理收款码' },
    // { value: 4013, label: '贸易增量' },
    { value: 4014, label: '项目融资' },
    { value: 4015, label: '无本续贷' }
  ]
}
// 财务管理 渠道等级
export const identityOptions = [
  { label: '助贷中介', value: 1 },
  { label: '助贷服务', value: 2 },
  { label: '贷款客户', value: 3 }
]
// 税票报告纳税等级
export const taxReportLevelOptions = [
  { label: 'A（近1年20万以上）', value: 'A' },
  { label: 'B（近1年5~20万）', value: 'B' },
  { label: 'C（近1年1~5万）', value: 'C' },
  { label: 'D（近1年小于1万）', value: 'D' }
]
// 税票报告开票等级
export const taxInvoicingLevelOptions = [
  { label: 'A（近1年2000万以上）', value: 'A' },
  { label: 'B（近1年500~2000万）', value: 'B' },
  { label: 'C（近1年100~500万）', value: 'C' },
  { label: 'D（近1年小于100万）', value: 'D' }
]
// 征信报告类型
export const creditReportOptions = [
  { label: '全部', value: '' },
  { label: '简版', value: 2 },
  { label: '详版', value: 1 }
]
// 征信报告数据反馈类型
export const creditReportDataOptions = [
  // { label: '全部', value: '' },
  { label: '认可', value: 1 },
  { label: '不认可', value: 2 },
  { label: '暂无', value: 0 }
]
export const uploadOptions = [
  {
    label: '全部',
    value: ''
  },
  {
    label: '渠道上传',
    value: 0
  },
  {
    label: '渠道邀请上传',
    value: 1
  }
]
// 征信报告数据-是否逾期枚举值
export const isOverdueOptions = [
  {
    label: '全部',
    value: ''
  },
  {
    label: '是',
    value: 1
  },
  {
    label: '否',
    value: 0
  }
]

// 税票报告-状态枚举值
export const taxStatusOptions = [
  {
    label: '待生成',
    value: 0
  },
  {
    label: '生成中',
    value: 1
  },
  {
    label: '已生成',
    value: 2
  },
  {
    label: '生成失败',
    value: 3
  }
]
// 征信报告-状态枚举值
export const creditReportStatusOptions = [
  {
    label: '待生成',
    value: 0
  },
  {
    label: '生成中',
    value: 1
  },
  {
    label: '已生成',
    value: 2
  },
  {
    label: '生成失败',
    value: 3
  }
]
// 运营管理-内容管理-状态枚举值 1草稿 2待生效 3生效中 4已下架 5已失效
export const contentStatusOptions = [
  {
    label: '草稿',
    value: 1
  },
  {
    label: '待生效',
    value: 2
  },
  {
    label: '生效中',
    value: 3
  },
  {
    label: '已下架',
    value: 4
  },
  {
    label: '已失效',
    value: 5
  }
]
export const isMeIsChannelAgent = [
  // {
  //   label: '全部',
  //   value: ''
  // },
  {
    label: '是',
    value: true
  },
  {
    label: '否',
    value: false
  }
]
